"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviewImageNode = exports.getPreviewLinkNodes = exports.enhanceMarkdown = exports.capitalizeFirstLetter = exports.TINA_TEMPLATE_KEY_NAME = exports.MARKDOWN_LINK_IMAGE_REG_EXP = void 0;
exports.MARKDOWN_LINK_IMAGE_REG_EXP = /\[(.*)\]\((.*?)(\s"(.*)")?\)/gm;
exports.TINA_TEMPLATE_KEY_NAME = "_template";
var capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
var enhanceMarkdown = function (markdown, 
// eslint-disable-next-line no-unused-vars
fileResolver, 
// eslint-disable-next-line no-unused-vars
fileIdResolver) {
    var enhancedMarkdown = markdown.replace(exports.MARKDOWN_LINK_IMAGE_REG_EXP, function (_match, label, file, _titleSegment, title) {
        var fileNode = fileResolver(file);
        if (fileNode) {
            return "[".concat(label || "", "](file:").concat(fileIdResolver(fileNode)).concat(title ? " \"".concat(title, "\"") : "", ")");
        }
        return "[".concat(label || "", "](").concat(file || "").concat(title ? " \"".concat(title, "\"") : "", ")");
    });
    return enhancedMarkdown;
};
exports.enhanceMarkdown = enhanceMarkdown;
var getPreviewLinkNodes = function (linkNodes) {
    return linkNodes === null || linkNodes === void 0 ? void 0 : linkNodes.map(function (_linkNode) {
        var _a, _b;
        var linkNode = _linkNode;
        var genericTypeName = (_a = linkNode === null || linkNode === void 0 ? void 0 : linkNode.__typename.match(/LinkNodes([A-Za-z]+)/)) === null || _a === void 0 ? void 0 : _a[1];
        switch (genericTypeName) {
            case "InternalLink": {
                return __assign(__assign({}, linkNode), { internalLink: {
                        childPage: {
                            path: "/".concat((_b = linkNode.internalLink) === null || _b === void 0 ? void 0 : _b.path),
                        },
                    } });
            }
            case "ExternalLink": {
                return linkNode;
            }
            case "FileLink": {
                return __assign(__assign({}, linkNode), { fileLink: {
                        publicURL: linkNode.fileLink,
                    } });
            }
            default: {
                return linkNode;
            }
        }
    });
};
exports.getPreviewLinkNodes = getPreviewLinkNodes;
var getPreviewImageNode = function (imageNode, alias) {
    if (typeof imageNode !== "object") {
        return null;
    }
    var imageNodePreview = __assign({}, imageNode);
    (alias || ["image"]).forEach(function (key) {
        // @ts-expect-error
        imageNodePreview[key] = {
            __typename: "File",
            publicURL: imageNode && "image" in imageNode ? imageNode === null || imageNode === void 0 ? void 0 : imageNode.image : undefined,
        };
    });
    return imageNodePreview;
};
exports.getPreviewImageNode = getPreviewImageNode;
